<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            <i class="las" :class="$router.currentRoute.meta.icon"></i>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                        
                    <div class="row" v-if="detalhes">

                        <div class="col-xs-12 margin-bottom-25">
                            <div class="row">
                                <div class="col-xs-12 col-md-6 col-lg-4">
                                    <h5 class="margin-0">
                                        Descrição:
                                    </h5>
                                    <h3 class="margin-bottom-10">
                                        {{detalhes.itens[0].nome}}
                                    </h3>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-3">
                                    <h5 class="margin-0" style="text-align: right;">
                                        Valor:
                                    </h5>
                                    <h3 class="margin-bottom-10" style="text-align: right;">
                                        <b>R$ {{detalhes.valor | toMoney}}</b>
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12">
                            <div class="submit-field margin-bottom-15 padding-bottom-0">
                                <h5 class="margin-0">
                                    Selecione a forma de pagamento:
                                </h5>
                            </div>     
                        </div>

                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    <div class="radio radio-card">
                                        <input style="background: transparent !important; border: 0px !important" id="radio-2" name="radio" type="radio" v-model="form.formaPagamento" value="boleto">
                                        <label for="radio-2"><span class="radio-label"></span>
                                            Boleto
                                            <i class="las la-barcode"style="float: right; font-size: 24px;"></i>
                                            <small style="color: red; display: block; width: 100%; line-height: 130%; font-size: 12px;">
                                                Demora em média 48h para o sistema detectar o pagamento.
                                            </small>
                                        </label>
                                    </div>                                                          
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                    <div class="radio radio-card">
                                        <input style="background: transparent !important; border: 0px !important" id="radio-1" name="radio" type="radio" v-model="form.formaPagamento" value="pix">
                                        <label for="radio-1"><span class="radio-label"></span>
                                            PIX
                                            <i class="las la-clipboard"style="float: right; font-size: 24px;"></i>
                                            <small style="color: red; display: block; width: 100%; line-height: 130%; font-size: 12px;">
                                                Liberação na hora.
                                            </small>
                                        </label>
                                    </div>                                                          
                                </div>                                
                                <div class="col-xs-12 col-sm-6">
                                    <div class="radio radio-card">
                                        <input style="background: transparent !important; border: 0px !important" id="radio-4" name="radio" type="radio" v-model="form.formaPagamento" value="adicionar-cartao-de-credito">
                                        <label for="radio-4"><span class="radio-label"></span>
                                            Adicionar cartão de crédito
                                            <i class="las la-plus-square" style="float: right; font-size: 24px;"></i>
                                            <small style="color: red; display: block; width: 100%; line-height: 130%; font-size: 12px;">
                                                Liberação na hora.
                                            </small>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6" v-for="(item, index) in formasPagamento.itens">
                                    <div class="radio radio-card">
                                        <input style="background: transparent !important; border: 0px !important" :id="'radio-cartao-' + index" name="radio" type="radio" v-model="form.formaPagamento" :value="item">
                                        <label :for="'radio-cartao-' + index"><span class="radio-label"></span>
                                            Cartão <b>{{item.bandeira.toUpperCase()}}</b> final {{item.ultimosDigitos}} 
                                            <a v-on:click.stop.prevent="delCartao(item)" style="margin-left: 5px"><i style="color: red; font-weight: bold; font-size: 20px; position: relative; top: 2px" class="las la-times-circle"></i>
                                            </a>
                                            <i class="las la-credit-card" style="float: right; font-size: 24px;"></i>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="form.formaPagamento == 'adicionar-cartao-de-credito'">
                            <form class="form-elements margin-top-10" method="post" v-on:submit.prevent="addCartao" novalidate="" autocomplete="off">
                                <div class="list cartao-de-credito">
                                    <ul class="row padding-left-15 padding-right-15">
                                        <li class="item-content item-input item-input-with-value col-lg-6 col-xs-12">
                                            <div class="item-inner">
                                                <label class="form-label">Nome do titular do cartão</label>
                                                <div class="item-input-wrap">
                                                    <input type="text" v-model="formCartao.nome" placeholder="Escreva seu nome.." class="form-control input-with-value">
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input item-input-with-value col-lg-4 col-xl-3 col-xs-8">
                                            <div class="item-inner">
                                                <label class="form-label">CPF do titular do cartão</label>
                                                <div class="item-input-wrap">
                                                    <the-mask :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="formCartao.doc" placeholder="Informe seu CPF" required />
                                                </div>
                                            </div>
                                        </li>                                
                                        <li class="item-content item-input col-lg-4">
                                            <div class="item-inner">
                                                <label class="form-label">Número do cartão</label>
                                                <div class="item-input-wrap">
                                                    <the-mask :mask="['#### #### #### ####']" type="tel" class="form-control" autocomplete="new-password" v-model="formCartao.numero" placeholder="____ ____ ____ ____" required />
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input col-lg-2 col-xs-6">
                                            <div class="item-inner">
                                                <label class="form-label">Mês</label>
                                                <div class="item-input-wrap">
                                                    <the-mask :mask="['##']" type="tel" class="form-control" autocomplete="new-password" v-model="formCartao.mes" placeholder="__" required />
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input col-lg-2 col-xs-4">
                                            <div class="item-inner">
                                                <label class="form-label">Ano</label>
                                                <div class="item-input-wrap">
                                                    <select class="with-border" required="" id="cardExpirationYear" v-model="formCartao.ano" onselectstart="return false" onpaste="return false" oncopy="return false" oncut="return false" ondrag="return false" ondrop="return false" autocomplete=off>
                                                        <option value="" disabled selected hidden>Ano</option>
                                                        <option v-for="item in anos" v-bind:value="item" >20{{ item }}</option>
                                                    </select>                                                       
                                                </div>
                                            </div>
                                        </li>                                
                                        <li class="item-content item-input col-lg-2 col-xs-5">
                                            <div class="item-inner">
                                                <label class="form-label">CVV</label>
                                                <div class="item-input-wrap">
                                                    <the-mask :mask="['####']" type="tel" class="form-control" autocomplete="new-password" v-model="formCartao.cvv" placeholder="____" required />
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="row padding-left-15 padding-right-15">
                                        <li class="item-content item-input col-lg-4 col-xs-6 col-xl-3">
                                            <div class="item-inner">
                                                <label class="form-label">CEP</label>
                                                <div class="item-input-wrap">
                                                    <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="formCartao.enderecoCep" placeholder="_____-___" @keyup.native="atualizarCEP" />
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="row padding-left-15 padding-right-15">
                                        <li class="item-content item-input item-input-with-value col-lg-8">
                                            <div class="item-inner">
                                                <label class="form-label">Endereço</label>
                                                <div class="item-input-wrap">
                                                    <input type="text" v-model="formCartao.endereco" placeholder="Escreva seu endereço aqui..." value="" class="form-control input-with-value">
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input col-lg-4 col-xs-6">
                                            <div class="item-inner">
                                                <label class="form-label">Número</label>
                                                <div class="item-input-wrap">
                                                    <input type="text" v-model="formCartao.enderecoNumero" placeholder="___" class="form-control">
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input item-input-with-value col-lg-4">
                                            <div class="item-inner">
                                                <label class="form-label">Bairro</label>
                                                <div class="item-input-wrap">
                                                    <input type="text" v-model="formCartao.enderecoBairro" placeholder="Escreva seu bairro.." value="" class="form-control input-with-value">
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input col-lg-4">
                                            <div class="item-inner">
                                                <label class="form-label">Cidade</label>
                                                <div class="item-input-wrap">
                                                    <input type="text" v-model="formCartao.enderecoCidade" placeholder="Escreva sua cidade.." class="form-control">
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item-content item-input item-input-with-value col-lg-4">
                                            <div class="item-inner">
                                                <label class="form-label">Estado</label>
                                                <div class="item-input-wrap input-dropdown-wrap margin-bottom-0">
                                                    <select name="entregaEnderecoEstado" v-model="formCartao.enderecoEstado" class="form-control default-select input-with-value">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option value="AC">Acre</option>
                                                        <option value="AL">Alagoas</option>
                                                        <option value="AP">Amapá</option>
                                                        <option value="AM">Amazonas</option>
                                                        <option value="BA">Bahia</option>
                                                        <option value="CE">Ceará</option>
                                                        <option value="DF">Distrito Federal</option>
                                                        <option value="ES">Espírito Santo</option>
                                                        <option value="GO">Goiás</option>
                                                        <option value="MA">Maranhão</option>
                                                        <option value="MT">Mato Grosso</option>
                                                        <option value="MS">Mato Grosso do Sul</option>
                                                        <option value="MG">Minas Gerais</option>
                                                        <option value="PA">Pará</option>
                                                        <option value="PB">Paraíba</option>
                                                        <option value="PR">Paraná</option>
                                                        <option value="PE">Pernambuco</option>
                                                        <option value="PI">Piauí</option>
                                                        <option value="RJ">Rio de Janeiro</option>
                                                        <option value="RN">Rio Grande do Norte</option>
                                                        <option value="RS">Rio Grande do Sul</option>
                                                        <option value="RO">Rondônia</option>
                                                        <option value="RR">Roraima</option>
                                                        <option value="SC">Santa Catarina</option>
                                                        <option value="SP">São Paulo</option>
                                                        <option value="SE">Sergipe</option>
                                                        <option value="TO">Tocantins</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                    <div class="row padding-left-15 padding-right-15 margin-top-30">
                                        <div class="col-xs-12 col-md-6 col-lg-4">
                                            <button type="submit" class="button button-fill block-mobile color-green">
                                                <i class="las la-save"></i>
                                                Salvar cartão
                                            </button>
                                        </div>
                                        <div class="col-xs-12 col-md-12 col-lg-8">
                                            <small style="line-height: 130%; margin-bottom: 20px; display: block; margin-top: 15px">
                                                <i class="las la-lock"></i>
                                                Fique tranquilo(a), você está em um ambiente seguro e os seus dados estão protegidos.
                                            </small>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>

                        <div v-if="form.formaPagamento == 'pix' && pixChave" class="col-xs-12">
                            <div class="submit-field margin-top-10 margin-bottom-0 padding-bottom-0">
                                <p class="margin-0">
                                    <i class="las la-qrcode"></i>
                                    Pague via PIX
                                </p>
                            </div>
                            <div>
                                
                                <img :src="pixQrCode" style="width: 200px; margin-bottom: 10px;">

                                <a v-on:click="copiarPixChave" class="button small button-fill color-gray mb-10">
                                    <i class="las la-clipboard"></i>
                                    Copiar chave PIX
                                </a>

                                <small style="display: block; line-height: 130%; font-size: 12px; margin-top: 10px; color: red !important">
                                    <i class="las la-exclamation-triangle"></i>
                                    Válida até: {{pixVencimento | formatDate}}
                                </small>    

                                <small style="display: block; line-height: 130%; font-size: 12px; margin-top: 10px; color: red !important">
                                    <i class="las la-hourglass-start"></i>
                                    O pagamento será detectado <b>automaticamente</b>. 
                                </small>                    
                            </div>
                        </div>                                    


                        <div v-if="form.formaPagamento == 'boleto' && boletoLink" class="col-xs-12">
                            <div class="submit-field margin-top-10 margin-bottom-0 padding-bottom-0">
                                <p class="margin-0">
                                    <i class="las la-barcode"></i>
                                    Pague o boleto
                                </p>
                            </div>
                            <div>
                                <a target="_blank" :href="boletoLink" class="button small button-fill color-gray mb-10">
                                    <i class="las la-external-link-alt"></i>
                                    Visualizar boleto
                                </a>
                                <a v-on:click="copiarBoletoCodigo" class="button small button-fill color-gray mb-10">
                                    <i class="las la-clipboard"></i>
                                    Copiar código de barras
                                </a>

                                <small style="display: block; line-height: 130%; font-size: 12px; margin-top: 10px; color: red !important">
                                    <i class="las la-exclamation-triangle"></i>
                                    Vencimento do boleto: {{boletoVencimento | formatDate}}
                                </small>    

                                <small style="display: block; line-height: 130%; font-size: 12px; margin-top: 10px; color: red !important">
                                    <i class="las la-hourglass-start"></i>
                                    O pagamento será detectado <b>automaticamente</b>. Geralmente é detectado no dia seguinte ao pagamento, mas pode levar até 48h.
                                </small>                    
                            </div>
                        </div>

                        <div class="col-xs-12" v-bind:class="{'disabled': $root.user.tipo != 'contratante'}">
                            <div class="row">
                                <div class="col-xs-12 margin-top-10 margin-bottom-10">
                                    <hr>
                                </div>
                                <div class="col-xs-12 margin-top-15">
                                    <button v-if="form.formaPagamento && form.formaPagamento != 'adicionar-cartao-de-credito' && !boletoLink"  type="button" v-on:click="submit" class="button button-fill color-green block-mobile">
                                        <i class="las la-check-circle"></i>
                                        Efetuar pagamento
                                    </button>
                                </div>
                                <div class="col-xs-12 margin-top-15">
                                    <button v-if="form.formaPagamento == 'boleto' && boletoLink"  type="button" v-on:click="boletoPago" class="button button-fill gray block-mobile">
                                        <i class="las la-check-circle"></i>
                                        Já efetuei o pagamento
                                    </button>
                                </div>                                
                            </div>
                        </div>
                    </div>                    

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>

</template>


<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Pagamento',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "key":                  self.$root.config.pagarme.key,
            "boletoLink":           null,
            "boletoCodigo":         null,
            "boletoVencimento":     null,
            "pixChave":             null,
            "pixQrCode":            null,
            "pixVencimento":        null,                        
            "anos":                 [],
            "loading":              false,
            "loaded":               false,
            "formasPagamento": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "form": {
                "acao":             "pagamento",
                "formaPagamento":   ""
                // "cartaoMes":        "",
                // "cartaoAno":        "",
            },
            "formCartao": {
                "ano": ""
            },
            "detalhes":             null
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },           
    },      
    watch: {
        "form.formaPagamento": function(val) {
            console.log("change > form.formaPagamento()", val);
            var self = this;

            self.changeFormaPagamento();
        }
    },
    methods: {
        boletoPago: function() {
            var self = this;
            alert("Ok, obrigado! O pagamento do boleto será detectado automaticamente em até 48h úteis.");
            self.$root.back();
        },
        copiarBoletoCodigo: function() {
            var self = this;
            console.log("copiarBoletoCodigo()", self.boletoCodigo);
            copyTextToClipboard(self.boletoCodigo);
        },      
        pixPago: function() {
            var self = this;
            alert("Ok! O pagamento será detectado automaticamente em segundos... Aguarde por favor.");
        },        
        copiarPixChave: function() {
            var self = this;
            console.log("copiarPixChave()", self.pixChave);
            copyTextToClipboard(self.pixChave);
        },                    
        initCartaoAnos: function() {
            var self    = this;
            var data    = new Date()
            data        = data.getFullYear()
            var dataFim = data + 11
            var anos    = []
            for (var index = 0; data < dataFim; data++, index++) {
                anos.push(data.toString().substr(2, 4))   
            }
            self.anos   = anos;
        },            
        addCartao: function() {
            var self = this;
            console.log("submit()");
            
            loading.show();

            if (parseInt(self.formCartao.mes) < 10 && self.formCartao.mes.toString().length == 1) {
                self.formCartao.mes = "0" + self.formCartao.mes.toString();
            }

            var card = {} 
            card.card_holder_name       = self.formCartao.nome;
            card.card_expiration_date   = self.formCartao.mes + '/' + self.formCartao.ano;
            card.card_number            = self.formCartao.numero;
            card.card_cvv               = self.formCartao.cvv;

            console.log("Form card:", card)

            // pega os erros de validação nos campos do form e a bandeira do cartão
            var cardValidations = pagarme.validate({card: card})
                    
            //Então você pode verificar se algum campo não é válido
            if(!cardValidations.card.card_number) {
                loading.hide();
                alert('Erro! Número do cartão inválido');
                return false;
            }

            if(!cardValidations.card.card_expiration_date) {
                loading.hide();
                alert('Erro! Vencimento do cartão inválido');
                return false;
            }        

            if(!cardValidations.card.card_holder_name) {
                loading.hide();
                alert('Erro! Nome do titular do cartão inválido');
                return false;
            }                                

            if(!cardValidations.card.card_cvv) {
                loading.hide();
                alert('Erro! CVV do cartão inválido');
                return false;
            }                    
             
            //Mas caso esteja tudo certo, você pode seguir o fluxo

            const options = {
                method: 'POST',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify({
                    card: {
                        number:         self.formCartao.numero,
                        holder_name:    self.formCartao.nome,
                        exp_month:      self.formCartao.mes,
                        exp_year:       self.formCartao.ano,
                        cvv:            self.formCartao.cvv,
                        label:          null
                    },
                    type:               'card'
                })
            };

            fetch('https://api.pagar.me/core/v5/tokens?appId=' + self.key, options)
            .then(response => response.json())
            .then(function(response) {
                
                loading.hide();
                console.log("addCartao() response", response);
                self.formCartao.token = response.id;
                self.submitCartao();      
          
            }).catch(function(error) {

                console.log("hash error", error);                      
                loading.hide();
                // alert(error);
                alert("Erro! " +  error.message);

            });   
        },      
        atualizarCEP: function() {
            var self    = this;
            setTimeout(function() {
                var val = self.formCartao.enderecoCep;
                if (val) {
                    if (val.length == 9) {
                        axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                        .then(response => {
                            if (response.data) {
                                if (response.data.logradouro) {
                                    self.formCartao.endereco            = response.data.logradouro;
                                    self.formCartao.enderecoBairro      = response.data.bairro;
                                    self.formCartao.enderecoCidade      = response.data.localidade;
                                    self.formCartao.enderecoEstado      = response.data.uf;
                                    self.$forceUpdate();
                                }
                            }
                        })
                        .catch(error => {
                        });
                    }
                }
            }, 1);    
        },          
        getFormasPagamento: function() {
            console.log("getFormasPagamento()");
            var self = this;
            return new Promise(function(resolve, reject) {

                loading.show();
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "formas-de-pagamento"
                    }
                };

                axios.get("api/carteira.php", form)
                .then(response => {
                    
                    console.log("getFormasPagamento() response", response.data);
                    self.formasPagamento = response.data.result;
                    self.$forceUpdate();

                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getFormasPagamento() error", error);
                    loading.hide();
                    
                    reject(error);
                    
                }); 
            });             
        },        
        submit: function() {
            // return false;
            var self            = this;
            console.log("submit", self.form);
            
            var form                                = JSON.parse(JSON.stringify(self.form));
            form._cod                               = self.$root.user.cod;
            form._token                             = self.$root.user.token;            
            var forma                               = self.form.formaPagamento;

            if (typeof forma == "string") {

                form.formaPagamentoNome             =  form.formaPagamento.charAt(0).toUpperCase() + form.formaPagamento.slice(1);;
            } else {
                form.formaPagamento                 = forma.integracaoId;
                form.formaPagamentoNome             = "Cartão de crédito " + forma.bandeira;
            }            

            console.log("Form:", JSON.stringify(form));

            loading.show();
            
            var url     = "api/pedidos.php";
            if (self.detalhes.tipo == "plano") {
                url     = "api/assinatura.php";
            }

            axios.post(url, form)
            .then(response => {
                console.log("ok", response)      

                if (response.data.result.boletoCodigo) {
                        
                    self.boletoCodigo       = response.data.result.boletoCodigo;
                    self.boletoVencimento   = response.data.result.boletoVencimento;
                    self.boletoLink         = response.data.result.link;

                    alert(response.data.message);
                    setTimeout(function() {
                        loading.hide();
                    }, 2000);
                
                } else if (response.data.result.pixChave) {

                    if (self.timer) {
                        clearInterval(self.timer);
                    }

                    self.timer = setInterval(function() {

                        console.log("Busca status pedido> ", response.data.result.cod);

                        var form = {
                            "params": {
                                "_cod":     self.$root.user.cod,
                                "_token":   self.$root.user.token,
                                "cod":      self.form.cod
                            }
                        };            

                        axios.get("api/pedidos.php", form)
                        .then(response => {
                            
                            console.log("getPedido() response", response);
                            if (response.data.result.pago == 1) {
                                alert("✅ Pagamento confirmado com sucesso, obrigado!");
                                // redireciona pra tela de historico
                                clearInterval(self.timer);
                                self.$root.go("Faturas");
                            }

                        })
                        .catch(error => {
                            console.log("getPedido() error", error);                    
                                            
                        });   
                    }, 1000);

                    self.pixChave           = response.data.result.pixChave;
                    self.pixVencimento      = response.data.result.pixVencimento;
                    self.pixQrCode          = response.data.result.link;

                    alert(response.data.message);
                    setTimeout(function() {
                        loading.hide();
                    }, 2000);

                } else {
                    alert(response.data.message);
                    setTimeout(function() {
                        loading.hide();
                        self.$root.go("Faturas");
                    }, 2000);         
                }
            })
            .catch(error => {
                loading.hide();                 
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },                 
        submitCartao: function() {
            var self    = this;
            if (self.loading) return false;
            console.log("submitCartao()");
            self.loading    = true;
            loading.show();
            var form        = JSON.parse(JSON.stringify(self.formCartao));
            form._cod       = self.$root.user.cod;
            form._token     = self.$root.user.token;
            form.acao       = "cartao";

            console.log("submitCartao() form", form);
                
            axios.put("api/carteira.php", form)
            .then(response => {
                
                console.log("submitCartao()", response)
                self.form.formaPagamento        = response.data.result;
                self.form.formaPagamentoNome    = "Cartão de crédito " + response.data.result.bandeira;
                self.form.formaPagamentoTipo    = "cartao-de-credito";

                setTimeout(function() {
                    self.loading = false;
                    self.$root.$forceUpdate();
                    self.$forceUpdate();
                    self.changeFormaPagamento();
                    self.getFormasPagamento().finally(function() {
                        loading.hide();
                    });
                }, 10);

            })
            .catch(error => {
                self.loading = false;
                console.log("submitCartao()", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },      
        changeFormaPagamento: function(e) {
            var self = this;

            console.log("changeFormaPagamento()", e);

            setTimeout(function() {
                console.log("Forma de pagamento:", self.form.formaPagamento);

                var forma = self.form.formaPagamento;

                self.boletoCodigo       = null;
                self.boletoVencimento   = null;
                self.boletoLink         = null;

                self.pixChave           = null;
                self.pixVencimento      = null;

                if (forma == "boleto") {
                    self.form.formaPagamentoNome    = "Boleto";
                    self.form.formaPagamentoTipo    = "boleto";                    
                }

                console.log("Setou FORM data", self.form)

            }, 100);            
        },
        delCartao: function(cartao) {
            var self = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                loading.show();
                var form        = {};
                form._cod       = self.$root.user.cod;
                form._token     = self.$root.user.token;
                form.acao       = "cartao";
                form.cod        = cartao.cod;               
                
                axios.delete("api/carteira.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    // loading.hide();  
                    self.getFormasPagamento();               
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });            
        },        
        get: function() {
            var self        = this;
            console.log("get()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":     self.$root.user.cod,
                        "_token":   self.$root.user.token,
                        "cod":      self.form.cod
                    }
                };            

                axios.get("api/pedidos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.detalhes           = response.data.result;
                    if (self.detalhes.pago == 1) {
                        alert("Essa fatura já foi paga.");
                        self.$root.back();
                    }
                    setTimeout(function() {
                        self.$forceUpdate();
                    }, 100);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                    
                });   
            });   
        }         
    },
    created: function() {
        var self = this;
        var load = true;
        self.scope = this;
        self.initCartaoAnos();

    },
    mounted: function() {
        console.log("mounted")
        var self = this;
        loading.show();
        self.form.cod   = self.$route.query.c;
        self.getFormasPagamento();
     
        setTimeout(function() {
            Promise.resolve()
            .then(self.get)
            .finally(function() {
                loading.hide();
            })
        }, 500);
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table-bordered th {
        padding-left: 5px;
        font-weight: 500;
        padding-right: 5px;
    }
    .table-bordered td {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 5px;
        padding-right: 5px;
    }
    .table-bordered thead th:last-child {
        border-left: 1px solid #ddd;
    }
    .table-bordered tr td:last-child {
        border-left: 1px solid #ddd;
    }

    .job-listing {
        box-shadow: none;
        margin-top: 20px;
        margin-bottom: 15px;
        border-radius: 0px !important;
    }

    .job-listing-details {
        padding: 10px;
        border-bottom: 1px solid #efefef;
        /*margin-bottom: 10px;*/
        padding-bottom: 0px;
    }

    .job-listing .job-listing-company-logo {
        max-width: 70px;
    }

    .job-listing-company-logo .img2 {
        width: 80px;
        height: 80px;        
    }

    .job-listing-description {
        width: calc(100% - 100px);
    }

    .job-listing h3.job-listing-title {
        height: 20px;
        width: auto;
        /*display: block;*/
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 16px;
        line-height: 110%;
        color: #555;
    }    

    .job-listing .delete {
        position: absolute;
        right: 10px;
        font-size: 18px;
        margin-top: -3px;
        background: transparent;
    }
    .job-listing .delete ion-icon {
        color: red !important;
    }
    .quantidade {
        position: relative;
        width: 120px;
    }

    .quantidade input {
        text-align: center; 
        height: 33px;
        line-height: 33px;
        border: 1px solid #ddd !important;
        box-shadow: none !important;
        /*padding-left: 0px;*/
    }

    .quantidade button:first-child {
        position: absolute;
        top: 0px;
        font-size: 24px;
        left: 5px;
        height: 33px;
        line-height: 35px;
        vertical-align: middle;
        color: #fe0100;
    }

    .quantidade button:last-child {
        position: absolute;
        top: 0px;
        font-size: 24px;
        right: 5px;
        height: 33px;
        line-height: 35px;
        vertical-align: middle;
        color: #fe0100;
    }  

    .icon-left {
        color: #92d14e;
        font-size: 34px;
        margin-right: -6px;
    }

    small.block {
        display: block;
        line-height: 130%;
        color: #333;
        text-align: center;
        margin-top: 10px;
        font-weight: 200 !important;
    }

    hr {
        opacity: 0.1;
    }

    .checkbox ion-icon {
        color: #92d14e;
        font-size: 20px;
    }

    .remover {
        float: right;
        margin-right: 5px;
        margin-top: 2px;
    }

    .item-inner {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Pagamento.vue